var map = {
	"./photo_2025-10-04_08-56-30.jpg": 463,
	"./photo_2025-10-04_15-41-31.jpg": 600,
	"./photo_2025-10-04_15-41-33.jpg": 514,
	"./photo_2025-12-14_20-45-14.jpg": 620,
	"./photo_2026-02-03_09-15-01.jpg": 330,
	"./photo_2026-02-03_09-15-02.jpg": 229,
	"./photo_2026-02-03_09-15-03.jpg": 96,
	"./photo_2026-02-03_09-15-04.jpg": 960,
	"./photo_2026-02-03_09-15-06.jpg": 817,
	"./photo_2026-02-03_09-15-07.jpg": 772,
	"./photo_2026-02-03_09-15-10.jpg": 936,
	"./photo_2026-02-03_09-15-11.jpg": 829,
	"./photo_2026-02-03_09-15-12.jpg": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;